import { Component, ViewChild } from "@angular/core";
import { NavController, Slides, ActionSheetController } from "ionic-angular";
import { DataProvider } from "../../providers/data/data";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  config: any;
  @ViewChild(Slides) slides: Slides;
  currentIndex: any = 0;
  countries: any;
  register: any = false;
  genealogie_step = 0;
  branches: any;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public navCtrl: NavController,
    public dataProvider: DataProvider,
  ) {
    this.initConfig();
    this.refresh();
  }
  ionViewDidLoad() {
    // this.mockup();
  }
  async refresh() {
    this.countries = await this.dataProvider.getCountries();
    console.log("this.countries", this.countries);
  }
  mockup() {
    this.currentIndex = 5;
    this.initBranches();
    this.branches[1].title = this.config.first_branch;
    this.branches[1].show = true;
    console.log("createFirstBranch", this.branches);
    this.register = true;
  }
  initConfig() {
    let today = new Date();
    today.setFullYear(1990, 0, 1);
    let default_date = new Date(today).toISOString();

    this.config = {
      prenom: "",
      birthday: default_date,
      country: "France",
      racines: [
        { title: "Racine 1", name: "", valeurs: "a définir" },
        { title: "Racine 2", name: "", valeurs: "a définir" },
        { title: "Racine 3", name: "", valeurs: "a définir" },
        { title: "Racine 4", name: "", valeurs: "a définir" }
      ],
      genealogie: [
        { title: "Racine 1", name: "Name 1", valeurs: "a définir" },
        { title: "Racine 2", name: "Name 2", valeurs: "a définir" },
        { title: "Racine 3", name: "Name 3", valeurs: "a définir" },
        { title: "Racine 4", name: "Name 4", valeurs: "a définir" }
      ]
    };
    // genealogie: [
    //   {title:"Racine 1",name:"Name 1",valeurs:"a définir",childs:[
    //     {title:"Racine 1.1",name:"Name 1.1",valeurs:"a définir"},
    //     {title:"Racine 1.2",name:"Name 1.2",valeurs:"a définir"}
    //   ]},
    //   {title:"Racine 2",name:"Name 2",valeurs:"a définir",childs:[
    //     {title:"Racine 2.1",name:"Name 2.1",valeurs:"a définir",childs:[
    //       {title:"Racine 2.1.1",name:"Name 2.1.1",valeurs:"a définir"},
    //       {title:"Racine 2.1.2",name:"Name 2.1.2",valeurs:"a définir"}
    //     ]},
    //     {title:"Racine 2.2",name:"Name 2.2",valeurs:"a définir"}
    //   ]},
    // ]
    console.log("this.config", this.config);
  }
  addBranch(data) {
    console.log("addBranch", data);
    if (data.length == 1)
      this.branches[data[0]++].show = true;
    if (data.length == 2)
      this.branches[data[0]].branches[data[1]].show = true;
  }
  addFeuille(data) {
    console.log("addFeuille", data);
    if (data.length == 1)
      this.branches[data[0]++].show = true;
    if (data.length == 2)
      this.branches[data[0]].feuilles[data[1]].show = true;
    if (data.length == 3)
      this.branches[data[0]].branches[data[1]].feuilles[data[2]].show = true;
  }
  addFleur(data) {
    console.log("addFleur", data);
    if (data.length == 1)
      this.branches[data[0]++].show = true;
    if (data.length == 2)
      this.branches[data[0]].fleurs[data[1]].show = true;
    if (data.length == 3)
      this.branches[data[0]].branches[data[1]].fleurs[data[2]].show = true;
  }
  clickTree() {
    console.log("clickTree");
    let buttons = [];

    // Add branch
    let add_branch = null;
    for (let i = 1; i < this.branches.length; i++) {
      if (this.branches[i].show == false) {
        add_branch = [i];
        break;
      }
    }
    if (add_branch != null) {
      buttons.push({
        text: "🎍Ajouter une branche",
        role: "action",
        handler: () => {
          this.addBranch(add_branch);
          console.log("Cancel clicked");
        }
      });
    }

    buttons.push({
      text: "Annuler",
      role: "cancel",
      handler: () => {
        console.log("Cancel clicked");
      }
    });
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Quelle action faire ?',
      buttons: buttons
    });

    actionSheet.present();
  }

  clickBranch(level1, level2 = null) {
    console.log("clickBranch", level1, level2);
    let buttons = [];

    // Add branch
    let add_branch = null;
    let add_feuille = null;
    let add_fleur = null;
    if (level2 == null) {
      for (let i = 1; i < this.branches[level1].branches.length; i++) {
        if (this.branches[level1].branches[i].show == false) {
          add_branch = [level1, i];
          break;
        }
      }
      for (let i = 1; i < this.branches[level1].fleurs.length; i++) {
        if (this.branches[level1].fleurs[i].show == false) {
          add_fleur = [level1, i];
          break;
        }
      }
    }
    else {
      if(this.branches[level1].branches[level2].branches)
      for (let i = 1; i < this.branches[level1].branches[level2].length; i++) {
        if (this.branches[level1].branches[level2].branches[i].show == false) {
          add_branch = [level1, level2, i];
          break;
        }
      }
      if(this.branches[level1].branches[level2].feuilles)
      for (let i = 1; i < this.branches[level1].branches[level2].feuilles.length; i++) {
        if (this.branches[level1].branches[level2].feuilles[i].show == false) {
          add_feuille = [level1, level2, i];
          break;
        }
      }
      if(this.branches[level1].branches[level2].fleurs)
      for (let i = 1; i < this.branches[level1].branches[level2].fleurs.length; i++) {
        if (this.branches[level1].branches[level2].fleurs[i].show == false) {
          add_fleur = [level1, level2, i];
          break;
        }
      }

    }
    if (add_branch != null && add_fleur != null && add_feuille != null)
      return;
    console.log("add_branch", add_branch);
    console.log("add_feuille", add_feuille);
    console.log("add_fleur", add_fleur);
    if (add_branch != null) {
      buttons.push({
        text: "🎍Ajouter une branche",
        role: "action",
        handler: () => {
          this.addBranch(add_branch);
          console.log("Cancel clicked");
        }
      });
    }
    if (add_fleur != null) {
      buttons.push({
        text: "🌸Ajouter une fleur",
        role: "action",
        handler: () => {
          console.log("Cancel clicked");
          this.addFleur(add_fleur);
        }
      });
    }
    if (add_feuille != null) {
      buttons.push({
        text: "🌿 Ajouter une feuille",
        role: "action",
        handler: () => {
          console.log("Cancel clicked");
          this.addFeuille(add_feuille);
        }
      });
    }
    buttons.push({
      text: "Annuler",
      role: "cancel",
      handler: () => {
        console.log("Cancel clicked");
      }
    });
    // {
    //   text: 'Destructive',
    //   role: 'destructive',
    //   handler: () => {
    //     console.log('Destructive clicked');
    //   }
    // }
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Quelle action faire ?',
      buttons: buttons
    });

    actionSheet.present();
  }

  clickLeaf(level1, level2 = null) {
    console.log("clickLeaf", level1, level2);
  }

  clickFlower(level1, level2 = null) {
    console.log("clickFlower", level1, level2);
  }
  createFirstBranch() {
    this.initBranches();
    this.branches[1].title = this.config.first_branch;
    this.branches[1].show = true;
    this.register = true;
  }

  slideChanged() {
    this.currentIndex = this.slides.getActiveIndex();
    console.log("Current index is", this.currentIndex);
  }
  slidePrev() {
    this.slides.slidePrev();
  }
  slideNext() {
    this.slides.slideNext();
  }

  initBranches() {
    this.branches = [
      {},
      // Branch 1
      {
        show: false,
        fleurs: [
          {},
          {
            show: false
          }
        ],
        branches: [
          {},
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          },
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          },
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              }
            ]
          },
        ]
      },
      // Branch 2
      {
        show: false,
        fleurs: [
          {},
          {
            show: false
          }
        ],
        branches: [
          {},
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          },
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          },
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          }
        ]
      },
      // Branch 3
      {
        show: false,
        branches: [
          {},
          {
            show: false,
            feuilles: [
              {},
              {
                show: false
              },
              {
                show: false
              },
              {
                show: false
              }
            ],
            fleurs: [
              {},
              {
                show: false
              }
            ]
          },
        ]
      },
      // Branch 4
      {
        show: false,
        branches: [

        ]
      },
      // Branch 5
      {
        show: false,
        branches: [

        ]
      }
    ];
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts